<nav class="navbar  navbar-premium">

    <div class="container d-flex">

        <!-- Logo -->
        <a class="navbar-brand" routerLink="/">
            <!-- Option 1: Logo Image -->
            <img src="imgs/sb.svg" alt="SoniBiz">


            <span>SONIBIZ</span>
        </a>



        <!-- Right Actions -->
        <div class="d-flex">

            <button class="btn btn-outline-primary">
                Learn More
            </button>

            <button class="btn btn-primary" [routerLink]="'/auth/join'">
                Join SoniBiz
            </button>

        </div>


    </div>

</nav>